import { authFetch } from "../helpers/FetchHelpers";

const { default: DataService } = require("./DataService");

class ShoppingDataService extends DataService {
    constructor() {
        super("shopping")
    }

    getShoppingList(page, perPage) {
        const body = {
            page,
            per_page: perPage,
        };

        return authFetch(process.env.REACT_APP_API_URL + '/shopping/list', 'POST', JSON.stringify(body))
            .then((data) => {
                const list = data.data?.data;
                const total = data.data?.total_data;

                return {
                    shoppingList: list ? list.map((shopping) => ({
                        Id: shopping.id,
                        ShoppingDate: shopping.shopping_date,
                        CreatorName: shopping.creator_name,
                        WarehouseId: shopping.warehouse_id,
                        Status: shopping.status,
                        TotalItem: shopping.total_item,
                        TotalPrice: shopping.total_price,
                    })) : undefined,
                    totalPages: total !== undefined ? (total < perPage ? 1 : Math.ceil(total / perPage)) : undefined,
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    getShoppingProductList(shoppingId, page, perPage) {
        const body = {
            shopping_id: shoppingId,
            page,
            per_page: perPage,
        };

        return authFetch(process.env.REACT_APP_API_URL + '/shopping/product/list', 'POST', JSON.stringify(body))
            .then((data) => {
                const list = data.data?.product_list;
                const total = data.data?.total_data;

                return {
                    shoppingDate: data.data?.shopping_date,
                    warehouseId: data.data?.warehouse_id,
                    status: data.data?.status,
                    productList: list ? list.map((item) => ({
                        Id: item.id,
                        ProductId: item.product_id,
                        ProductName: item.product_name,
                        ProductBarcode: item.product_barcode,
                        Quantity: item.quantity,
                        Price: item.price,
                        SellPrice: item.sell_price,
                        TotalPrice: item.total_price,
                    })) : undefined,
                    totalPages: total !== undefined ? (total < perPage ? 1 : Math.ceil(total / perPage)) : undefined,
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    addToCart(shoppingId, warehouseId, products) {
        const body = {
            shopping_id: shoppingId || 0,
            products,
        };

        if (!shoppingId) {
            body.warehouse_id = Number(warehouseId);
        }

        return authFetch(process.env.REACT_APP_API_URL + '/shopping/cart', 'POST', JSON.stringify(body))
            .then((data) => {
                return {
                    shoppingId: data.data?.shopping_id,
                    addedProducts: data.data?.added_products,
                    errorProducts: data.data?.error_products,
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    proceedShopping(shoppingId) {
        const body = {
            shopping_id: shoppingId,
        };

        return authFetch(process.env.REACT_APP_API_URL + '/shopping/proceed', 'POST', JSON.stringify(body))
            .then((data) => {
                return {
                    shoppingId: data.data?.shopping_id,
                    status: data.data?.status,
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    deleteProduct(shoppingId, productIds) {
        const body = {
            shopping_id: shoppingId,
            product_ids: productIds,
        };

        return authFetch(process.env.REACT_APP_API_URL + '/shopping/product/delete', 'POST', JSON.stringify(body))
            .then((data) => {
                return {
                    shoppingId: data.data?.shopping_id,
                    deletedProductIds: data.data?.deleted_product_ids,
                    deletedRow: data.data?.deleted_row,
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }
}

export default ShoppingDataService;
